module.exports = "pegasus/assets/email1-image-1.png";